import 'react-toastify/dist/ReactToastify.css';

import { AppProvider } from '@/shared/app/provider/provider';
import { GlobalStyle } from '@/shared/components/ui/global-style/global-style.styled';
import { Toast } from '@/shared/components/ui/toast/toast';
import { AppThemeProvider } from '@/shared/features/theme-switcher/context/theme-context';
import { useAuthListener } from '@/shared/hooks/use-auth-listener/use-auth-listener';

import { AppRouter } from './router';

export const ClassicExperience = () => {
  useAuthListener();

  return (
    <AppThemeProvider>
      <GlobalStyle />
      <Toast />
      <AppProvider>
        <AppRouter />
      </AppProvider>
    </AppThemeProvider>
  );
};
